/* nord-footer — JS estático extraído do <script> inline.
   Sem Liquid: idêntico em toda página, então vira asset cacheável. */
(function () {
    if (!customElements.get('nord-footer-accordion')) {
      customElements.define(
        'nord-footer-accordion',
        class NordFooterAccordion extends HTMLElement {
          connectedCallback() {
            this.details = this.querySelector('details');
            if (!this.details) return;
            this.query = window.matchMedia('(max-width: 699px)');
            this.sync = this.sync.bind(this);
            this.sync();
            // From 700px up the list is always visible: keep it from being toggled shut.
            this.details.addEventListener('toggle', function () {
              if (!this.collapsible() && !this.details.open) this.details.open = true;
            }.bind(this));
            if (this.query.addEventListener) {
              this.query.addEventListener('change', this.sync);
            } else {
              this.query.addListener(this.sync);
            }
          }

          disconnectedCallback() {
            if (!this.query) return;
            if (this.query.removeEventListener) {
              this.query.removeEventListener('change', this.sync);
            } else {
              this.query.removeListener(this.sync);
            }
          }

          collapsible() {
            return this.query.matches && !this.hasAttribute('data-always-open');
          }

          sync() {
            this.details.open = !this.collapsible();
          }
        }
      );
    }

    if (!window.nordFooterDisclosureBound) {
      window.nordFooterDisclosureBound = true;
      var closeAll = function (except) {
        document.querySelectorAll('[data-nord-disclosure][open]').forEach(function (el) {
          if (el !== except) el.open = false;
        });
      };
      document.addEventListener('click', function (event) {
        var open = event.target.closest ? event.target.closest('[data-nord-disclosure]') : null;
        closeAll(open);
      });
      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        var open = document.querySelector('[data-nord-disclosure][open]');
        if (!open) return;
        open.open = false;
        var toggle = open.querySelector('summary');
        if (toggle) toggle.focus();
      });
    }
  })();
